import { SafeInputType, inputIndex, type inputType } from './types';

export const getTotalDebt = (inputState: Record<string, inputType>): string => {
  const amount = Object.entries(inputState).reduce((acc, [_, value]) => {
    return value.confirmed ? acc + Number(value[inputIndex.AMOUNT]) : acc;
  }, 0) as number;
  return formatAmount(amount);
};

export const formatAmount = (amount: number) => {
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });
};

export const isSafeInputType = (debt: inputType): debt is SafeInputType =>
  debt.amount !== null && debt.institution !== '' && debt.debt_type !== '';
